import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useNote } from "../hooks/useNote";
import NoteDisplay from "./NoteDisplay";

const NoteDetail: React.FC = () => {
  const { noteid } = useParams<{ noteid: string }>();
  const navigate = useNavigate();

  const { note, loading, error } = useNote(noteid || "", false);

  const handleBack = () => {
    navigate("/notes");
  };

  return (
    <NoteDisplay
      note={note}
      loading={loading}
      error={error}
      identifier={noteid || ""}
      isURLFriendly={false}
      onBack={handleBack}
    />
  );
};

export default NoteDetail;
